module.exports = __webpack_public_path__ + "img/0922_1.eea12204.jpg";